

















import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";
import { CircleLayer } from "@/model/document2/page/surface/design/layer/circleLayer";
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class PatternStrokeWidthController extends Vue 
{
    @Prop() layer! : RectangleLayer | CircleLayer | PolygonLayer;

    private get strokeWidth()
    {
        return this.layer.strokeWidth;
    }

    private set strokeWidth(strokeWidth)
    {
        this.changeLayerProperty("strokeWidth", Number(strokeWidth), false, false);
    }

    private get strokeWidthText()
    {
        return this.layer.strokeWidth.toFixed(1) + "mm";
    }

    private onStrokeWidthChanged()
    {
        this.changeLayerProperty("strokeWidth", this.layer.strokeWidth, true, false);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
